<template>
  <div class="div-content">
    <img class="bg-img" src="@/assets/images/solution-header-bg.png" />
    <h1 class="p-text text-center">跨平台设备支持</h1>

    <h2 class="p-text text-center"><br />随时随地解决工厂管理问题</h2>
  </div>
</template>

<script>
export default {
  name: "SolutionHeader"
};
</script>

<style lang="stylus" scoped>
.div-content {
  position: relative;

  .bg-img {
    width: 100%;
  }

  .p-text {
    font-weight: 400;
    position: absolute;
    font-size: 3.5rem;
    letter-spacing: 0.3rem;
    color: #fff;
    top: 35%;
    width: 100%;
    text-align: center !important;
    line-height: 5.0rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/download/components/DownloadHeader.vue